import { Component, HostListener, OnDestroy } from '@angular/core';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { Router } from '@angular/router';
import { roleService } from 'src/app/services/role.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationList } from '../../interfaces/notification_liste.type';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { AuthService } from 'src/app/services/auth.service';   // -saml changes-
import { ChatBusService, isChatNotif, notifTitle } from 'src/app/services/chat-bus.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnDestroy {
  searchVisible: boolean = false;
  quickViewVisible: boolean = false;
  isFolded: boolean;
  isExpand : boolean = false;
  isRightSideNavOpen: boolean = false;
  // -menus off- demande du superviseur : menus Étudiant / Enseignant (barre rouge + menu mobile) masqués
  // pour l'instant. Mettre true pour les remettre (rien d'autre à changer).
  readonly showRoleMenus = false;
  rtl = document.documentElement.dir === 'rtl'; // -arabic- pose par main.ts (la page se recharge quand le sens change)
  user: any;
  projectListRaw: any[] = [];
  projectList: any[] = [];

  // -chat- compteurs de l'en-tête (messages non lus / notifications non lues), rafraîchis toutes les 20 s
  unreadMessages = 0;
  unreadNotifications = 0;
  notifOpen = false; // -chat fixes- cloche ouverte ; fermee apres un clic sur une notification
  private pollTimer: any;
  private busSub: Subscription;

  isMobileScreen = window.innerWidth < 992;

  @HostListener('window:resize', [])
  onResize() {
    this.isMobileScreen = window.innerWidth < 992;
    if (!this.isMobileScreen) {
      this.isRightSideNavOpen = false;
    }
  }

  constructor(
    private themeService: ThemeConstantService,
    private router: Router,
    public roleService: roleService,
    private http: HttpClient,
    private authService: AuthService,   // -saml changes-
    private bus: ChatBusService,        // -chat-
    private t: TranslateService         // -chat fixes- titres traduits
  ) {
    this.roleService = roleService;
  }

  ngOnInit(): void {
    this.themeService.isMenuFoldedChanges.subscribe(
      (isFolded) => (this.isFolded = isFolded)
    );
    this.themeService.isExpandChanges.subscribe(
      (isExpand) => (this.isExpand = isExpand)
    );

    const userString = localStorage.getItem('user');
    if (userString) {
      this.user = JSON.parse(userString);
      console.log('Utilisateur récupéré depuis localStorage :', this.user);
    }

    this.refreshNotifications();
    // -chat- quelque chose vient d'être lu (messagerie, page notifications) -> compteurs à jour tout de suite
    this.busSub = this.bus.countersChanged.subscribe(() => this.refreshNotifications());
    this.pollTimer = setInterval(() => {
      if (!document.hidden) this.refreshNotifications();
    }, 20000);
  }

  ngOnDestroy(): void {
    clearInterval(this.pollTimer);
    this.busSub?.unsubscribe();
  }

  /** -chat- Icône messagerie : ouvre la messagerie ; si on y est déjà, revient à la liste des conversations. */
  openChat(): void {
    if (this.router.url.startsWith('/apps/chat')) {
      this.bus.chatHome.next();
    } else {
      this.router.navigate(['/apps/chat']);
    }
    this.refreshNotifications();
  }

  private get headers(): HttpHeaders {
    return new HttpHeaders({ Authorization: `Bearer ${localStorage.getItem('token')}` });
  }

  /** -chat- Liste de la cloche + nombre de messages non lus. */
  refreshNotifications(): void {
    if (!localStorage.getItem('token')) return;
    this.http.get<any>(`${environment.apiUrl}/notifications/mine`, { headers: this.headers }).subscribe({
      next: (d) => {
        this.projectListRaw = d?.items || [];
        this.projectList = this.projectListRaw;
        this.unreadNotifications = d?.unread || 0;
      },
      error: () => {}
    });
    this.http.get<any>(`${environment.apiUrl}/chat/unread`, { headers: this.headers }).subscribe({
      next: (d) => this.unreadMessages = d?.messages || 0,
      error: () => {}
    });
  }

  /** -chat- Clic sur une notification : marquée lue, puis ouverture de sa page (ex. la conversation). */
  openNotification(item: any): void {
    if (!item.read) {
      item.read = true;
      this.unreadNotifications = Math.max(0, this.unreadNotifications - 1);
      this.http.post(`${environment.apiUrl}/notifications/mine/${item.id}/read`, {}, { headers: this.headers }).subscribe();
    }
    if (item.lien) {
      this.notifOpen = false; // -chat fixes- la cloche ne reste plus ouverte par-dessus la page ouverte
      this.router.navigateByUrl(item.lien);
    }
  }

  /** -chat fixes- titre affiche (messagerie : traduit) et type d'icone */
  title(item: any): string { return notifTitle(item, this.t); }
  isChat(item: any): boolean { return isChatNotif(item); }

  markAllRead(): void {
    this.http.post(`${environment.apiUrl}/notifications/mine/read-all`, {}, { headers: this.headers })
      .subscribe(() => this.refreshNotifications());
  }

  toggleFold() {
    this.isFolded = !this.isFolded;
    this.themeService.toggleFold(this.isFolded);
  }

  toggleExpand() {
    this.isFolded = false;
    this.isExpand = !this.isExpand;
    this.themeService.toggleExpand(this.isExpand);
    this.themeService.toggleFold(this.isFolded);
  }

  toggleRightSideNav() {
    this.isRightSideNavOpen = !this.isRightSideNavOpen;
  }

  searchToggle(): void {
    this.searchVisible = !this.searchVisible;
  }

  quickViewToggle(): void {
    this.quickViewVisible = !this.quickViewVisible;
  }

  // -saml changes- Déléguer au service : lui seul ferme aussi la session
  // Keycloak (redirection navigateur vers l'endpoint de logout). L'ancienne
  // copie locale ne vidait que le localStorage, le cookie Keycloak survivait
  // et reconnectait le compte précédent.
  logout() {
    this.authService.logout();
  }

  getNotifcationListFromApi(): Observable<NotificationList[]> {
    const token = localStorage.getItem('token'); // Remplace ceci par la récupération réelle du token (ex: depuis localStorage)

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    const userString = localStorage.getItem('user') || null;
    this.user = JSON.parse(userString);
    return this.http.get<NotificationList[]>(
      `${environment.apiUrl}/Notification/${this.user.id}`,
      { headers }
    ); // Ton endpoint API
  }
}